import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RoundMediaPlusContent from "../../ui/RoundMediaPlusContent";
import Image from "react-bootstrap/Image";
import computer from "../../../images/computer.png";
import BoostMoralecreativity from "../../../images/BoostMoralecreativity.jpg";
import stayConnected from "../../../images/connects.png";
import boostcreativityMedium from "../../../images/boosts.png";
// import Infotainment from "../../../images/Infotainment.jpg";
import HomeBanner from "../../ui/HomeBanner";
import images from "../../../images/images.jpg"
import informandentertainMedium from "../../../images/contents.png"
function Index() {
  return (
    <>
      <HomeBanner />
      <Container className="py-5 px-0">
        {/* <h3 className="text-center mb-5">Enjoy content while you work</h3> */}
        <Row className="content-justify-center my-3">
          <Col lg={12} xl={12}>
            <Row className="row-cols-3 row-cols-md-3 g-4 g-md-5">
              <Col>
                <RoundMediaPlusContent
                  image={boostcreativityMedium}
                  content="Boost morale,<br/>productivity & creativity "
                />
              </Col>

              <Col>
                <RoundMediaPlusContent
                  image={informandentertainMedium}
                  content="Curated Content to<br/>inform & entertain your workforce"
                />
              </Col>
              <Col>
                <RoundMediaPlusContent
                  image={stayConnected}
                  content="Stay Connected"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <div className="text-center mb-5">
          <Image src={computer} className="img-fluid" />
        </div>
        <h3 className="text-center mb-5">Compatible devices</h3>
        <Row className="justify-content-center text-center">
          <Col sm={6} md={4} lg={3}>
            <h5>Computer</h5>
            <ul className="p-0 list-unstyled">
              <li>Chrome OS</li>
              <li>Mac OS</li>
              <li>Windows PC</li>
            </ul>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <h5>Mobile & Tablet</h5>
            <ul className="p-0 list-unstyled">
              <li>Chrome OS</li>
              <li>Mac OS</li>
              <li>Windows PC</li>
            </ul>
          </Col>
        </Row> */}
      </Container>
    </>
  );
}

export default Index;
